export enum AdyenEnv {
  TEST = 'test',
  LIVE = 'live',
}
